import { Gender } from '@lmc/ts-common'
import { GenderIdentityEnum, type SexCode, SexEnum } from '@lmc/validations'

/**
 * When `demographics.sex` is missing, derive a suggested sex code for
 * confirmation — first from gender identity, then from legacy `gender`.
 */
export function getSuggestedSexForHospitalPassportPrompt(input: {
  genderIdentity?: string | null
  legacyGender?: Gender | string
}): SexCode | null {
  if (input.genderIdentity === GenderIdentityEnum.male) {
    return SexEnum.male
  }
  if (input.genderIdentity === GenderIdentityEnum.female) {
    return SexEnum.female
  }

  const legacy = input.legacyGender?.toString().toLowerCase()
  if (legacy === Gender.male) return SexEnum.male
  if (legacy === Gender.female) return SexEnum.female
  return null
}
